export const isDefaultValueError = (defaultValue?: number, minValue?: number, maxValue?: number): boolean => {
  if (defaultValue === undefined) return false;

  return (minValue !== undefined && defaultValue < minValue) || (maxValue !== undefined && defaultValue > maxValue);
};

export const isRangeValueError = (minValue?: number, maxValue?: number): boolean => {
  if (minValue === undefined || maxValue === undefined) return false;

  return maxValue < minValue;
};

export const getRangeErrors = (
  defaultValue?: number,
  minValue?: number,
  maxValue?: number,
): {
  isDefaultValueError: boolean;
  isRangeValueError: boolean;
  isAnyTargetValueError: boolean;
} => {
  const isDefaultValueValidationError = isDefaultValueError(defaultValue, minValue, maxValue);
  const isRangeValueErrorValidationError = isRangeValueError(minValue, maxValue);
  const isAnyTargetValueErrorValidationError = isDefaultValueValidationError || isRangeValueErrorValidationError;

  return {
    isDefaultValueError: isDefaultValueValidationError,
    isRangeValueError: isRangeValueErrorValidationError,
    isAnyTargetValueError: isAnyTargetValueErrorValidationError,
  };
};
